import { Badge, type BoxProps } from "@chakra-ui/react";
import { Icon } from "@src/components/ui-kit/Icon";
import { truncateFileName } from "@src/utils/truncateFileName";
import type React from "react";
import type { FC } from "react";

// TODO: link to download or just item???

interface FileItemProps extends BoxProps {
  fileName: string;
  url?: string | null;
}

export const FileItem: FC<React.PropsWithChildren<FileItemProps>> = ({
  fileName,
  url,
  ...props
}) => {
  return (
    <Badge
      as="a"
      _hover={{ bg: "grey.200" }}
      colorScheme="grey"
      href={url || undefined}
      target="_blank"
      {...props}
    >
      <Icon name="paperclip" w="4" h="4" mr="2" color="grey.600" />
      {truncateFileName(fileName, 45)}
    </Badge>
  );
};
